export const addresses = {
    "cCOMP": "0x70e36f6bf80a52b3b46b3af8e106cc0ed743e8e4",
    "cUSDC": "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
    "cDAI": "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
    "Comptroller": "0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B",
    "cUSDT": "0xf650C3d88D12dB855b8bf7D11Be6C55A4e07dCC9",
    "cBAT": "0x6C8c6b02E7b2BE14d4fA6022Dfd6d75921D90E4E",
    "cETH": "0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5",
    "cUNI": "0x35a18000230da775cac24873d00ff85bccded550",
    "cZRX": "0xB3319f5D18Bc0D84dD1b4825Dcde5d5f7266d407",
    "cWBTC legacy": "0xC11b1268C1A384e55C48c2391d8d480264A3A7F4",
    "cWBTC": "0xccF4429DB6322D5C611ee964527D42E5d685DD6a",
    "cTUSD": "0x12392f67bdf24fae0af363c24ac620a2f67dad86",
    "cLINK": "0xface851a4921ce59e912d19329929ce6da6eb0c7",
    "COMP": "0xc00e94cb662c3520282e6f5717214004a7f26888",
    /* B.Compound specific addresses
    ===================================================================== */
    "compUserInfoAddress": "0xe8986fb27cb7ee2575ed14133da4820be4a38228",
    "bComptrollerAddress": "0x9db10b9429989cc13408d7368644d4a1cb704ea3",
    "registryAddress": "0xbf698df5591caf546a7e087f5806e216afed666a",
    "sugerDady": "0x4F868C1aa37fCf307ab38D215382e88FCA6275E2",
    "compoundImportAddress": "0x035cccb015a826b754529b4d04587182b8210344",
    "flashImportAddress": "0xa5c48ef0301437bb2f5afdda8aedbe817f5e11d6",
    "jarConnector": "0xd24e557762589124d7cfef90d870df17c25bff8a",
    "jar": "0xb493d1b6048b801747d72f755b6efbfa1b4c6103",
    "compClaimData": "0x3a9cfE56604c5f4892950Ab3a3D9355901395B51"
}